<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <hint :value="inputHint" />
    <label :for="inputId" class="control-label">{{ inputLabel }}</label>
    <select
      v-model="inputValue"
      :id="inputId"
      :disabled="disabled"
      class="form-control show-tick"
      @change="emit"
      @input="emit"
      @blur="emit"
      @keyup.enter="emit"
      @keyup.delete="emit"
    >
      <option
        v-for="personalIdentification in items"
        v-bind:key="personalIdentification.id"
        :value="personalIdentification.id"
      >{{ personalIdentification.name }}
      </option>
    </select>
    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import visitorsSectionMixin from '../../../../mixins/application-form/visitorsSectionMixin'
import visitorInputMixin from '../../../../mixins/application-form/visitorInputMixin'
import Hint from '@/common/components/inputs/components/Hint.vue'

export default {
  name: 'IdentificationDocumentInput',

  components: { Hint },

  mixins: [applicationInputMixin, applicationFormMixin, visitorsSectionMixin, visitorInputMixin],

  props: {
    inputLabel: {
      default: 'Вид документа'
    },

    inputName: {
      default: 'identification_id'
    },

    inputHint: {
      default: undefined
    },

    items: {
      type: [Array, Object],
      default: () => []
    }
  },

  computed: {
    inputId () {
      let inputId = `form-visitor-identification-document-${this.visitorIndex}`
      if (this.transportIndex !== null) {
        return `form-visitor-transport-${this.transportIndex}-driver-${this.visitorIndex}-identification-document`
      }

      return inputId
    }
  },

  watch: {
    items(val) {
      if (val?.length === 1) {
        this.inputValue = val?.[0]?.id
      }
    }
  },

  created() {
    if (this.items?.length === 1) {
      this.inputValue = this.items?.[0]?.id
    }
  }
}
</script>
